export enum ThousandsSeparator
{
    Period = 1,
    Comma = 2,
    Space = 3
}
